import React, { useEffect, useState, useRef } from 'react';

const CursorFollower: React.FC = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isMoving, setIsMoving] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isTouchDevice, setIsTouchDevice] = useState(false);

    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    // 🔹 Détection stricte du tactile
    useEffect(() => {
        const hasTouch =
            'ontouchstart' in window ||
            navigator.maxTouchPoints > 0;

        setIsTouchDevice(hasTouch);
    }, []);

    // 🔹 Si tactile → on ne fait RIEN
    useEffect(() => {
        if (isTouchDevice) return;

        const handleMouseMove = (e: MouseEvent) => {
            setPosition({ x: e.clientX, y: e.clientY });

            if (!isVisible) setIsVisible(true);
            setIsMoving(true);

            if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setIsMoving(false), 150);
        };

        const handleMouseLeave = () => {
            setIsVisible(false);
            setIsMoving(false);

            if (timerRef.current) clearTimeout(timerRef.current);
        };

        const handleMouseEnter = () => {
            setIsVisible(true);
        };

        window.addEventListener('mousemove', handleMouseMove);
        document.body.addEventListener('mouseleave', handleMouseLeave);
        document.body.addEventListener('mouseenter', handleMouseEnter);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            document.body.removeEventListener('mouseleave', handleMouseLeave);
            document.body.removeEventListener('mouseenter', handleMouseEnter);

            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [isTouchDevice, isVisible]);

    // 🔹 Blocage total sur tactile
    if (isTouchDevice || !isVisible) return null;

    const circleSize = 20;

    return (
        <div
            className="fixed top-0 left-0 pointer-events-none z-[9999]"
            style={{
                transform: `translate(${position.x - circleSize / 2}px, ${position.y - circleSize / 2}px)`,
                width: `${circleSize}px`,
                height: `${circleSize}px`,
            }}
        >
            <div
                className={`w-full h-full rounded-full transition-all duration-200 ease-out ${
                    isMoving
                        ? 'bg-primary opacity-80 scale-110 shadow-lg'
                        : 'border-2 border-secondary bg-transparent'
                }`}
                style={{
                    boxShadow: isMoving ? '0 0 12px rgba(22,241,158,0.5)' : 'none',
                }}
            />
        </div>
    );
};

export default CursorFollower;